const LAST_INSTALLATION_STORAGE_KEY = 'operators_last_installation_id'

export function readLastInstallationId(): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  return window.localStorage.getItem(LAST_INSTALLATION_STORAGE_KEY)
}

export function writeLastInstallationId(installationId: string): void {
  if (typeof window === 'undefined') {
    return
  }
  window.localStorage.setItem(LAST_INSTALLATION_STORAGE_KEY, installationId)
}

export function pickDefaultInstallationId(
  installations: { id: string }[],
  lastId: string | null
): string | undefined {
  if (installations.length === 0) {
    return undefined
  }
  if (lastId && installations.some((item) => item.id === lastId)) {
    return lastId
  }
  return installations[0]!.id
}
